import React, { useEffect, useRef } from 'react';

// Matrix Rain Effect - Single random column at a time!
const MatrixRain = () => {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;

    const ctx = canvas.getContext('2d');
    
    // Set canvas size
    const resizeCanvas = () => {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
    };
    
    resizeCanvas();
    window.addEventListener('resize', resizeCanvas);

    // Matrix characters - B2P styled
    const matrix = 'B2P01BACK2PEOPLE01';
    const chars = matrix.split('');

    const fontSize = 14;
    let currentColumn = Math.floor(Math.random() * (canvas.width / fontSize));
    let dropY = 0;
    let isActive = false;
    let nextDropTime = Date.now() + Math.random() * 3000 + 2000; // Random delay between 2-5 seconds

    // Draw function
    const draw = () => {
      // Fade effect
      ctx.fillStyle = 'rgba(255, 255, 255, 0.05)';
      ctx.fillRect(0, 0, canvas.width, canvas.height);

      const now = Date.now();
      
      // Check if we should start a new drop
      if (!isActive && now >= nextDropTime) {
        isActive = true;
        currentColumn = Math.floor(Math.random() * (canvas.width / fontSize));
        dropY = 0;
      }

      // Draw the active column
      if (isActive) {
        ctx.fillStyle = '#000000';
        ctx.font = fontSize + 'px monospace';

        const text = chars[Math.floor(Math.random() * chars.length)];
        ctx.fillText(text, currentColumn * fontSize, dropY * fontSize);

        dropY++;

        // Reset when drop reaches bottom
        if (dropY * fontSize > canvas.height) {
          isActive = false;
          nextDropTime = Date.now() + Math.random() * 3000 + 2000; // Random delay between 2-5 seconds
        }
      }
    };

    // Animation loop
    const interval = setInterval(draw, 50);

    return () => {
      clearInterval(interval);
      window.removeEventListener('resize', resizeCanvas);
    };
  }, []);

  return (
    <canvas
      ref={canvasRef}
      className="matrix-background"
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        zIndex: -1,
        opacity: 0.05,
        pointerEvents: 'none'
      }}
    />
  );
};

export default MatrixRain;

